import { Field } from "../ui/field.tsx";
import { Controller, useFormContext } from "react-hook-form";
import {
  SelectContent,
  SelectItem,
  SelectRoot,
  SelectTrigger,
  SelectValueText,
} from "../ui/select.tsx";
import { ReactNode } from "react";

type ControlledDropdownProps = {
  label?: string;
  name: string;
  options: {
    value: string;
    label: string;
    icon?: string | ReactNode;
  }[];
  disabled?: boolean;
  resetDropdown?: () => void;
  className?: string;
  placeholder: string;
};

export const ControlledDropdown = ({
  label,
  options,
  disabled,
  name,
  className,
  placeholder,
}: ControlledDropdownProps) => {
  const { control } = useFormContext();

  return (
    <Field label={label} color={"#000000"} className={className}>
      <Controller
        control={control}
        name={name}
        render={({ field }) => {
          return (
            // @ts-expect-error
            <SelectRoot
              name={field.name}
              value={field.value}
              onValueChange={({ value }) => field.onChange(value)}
              onInteractOutside={() => field.onBlur()}
              disabled={disabled}
              color={"#000000"}
              variant={"outline"}
              size={"xs"}
              borderWidth={"1px"}
              borderColor={"#d3d3d3"}
              fontSize={"14px"}
              borderRadius={"0.5rem"}
              paddingLeft={"0.5rem"}
              className={className}
            >
              <SelectTrigger>
                <SelectValueText className="selected-text" color={"black"}>
                  {() => {
                    const selectedOption = options.find(
                      (option) => option.value === field?.value[0],
                    );
                    return selectedOption ? selectedOption.label : placeholder;
                  }}
                </SelectValueText>
              </SelectTrigger>
              <SelectContent>
                {options.map((option) => (
                  <SelectItem item={option} key={option.value}>
                    {option.label}
                  </SelectItem>
                ))}
              </SelectContent>
            </SelectRoot>
          );
        }}
      />
    </Field>
  );
};
